import request from './../../../utilities/request';
import localStorageToken from './../../../utilities/storage';

function reportAll() {
  return request({
    url:    `/action/wheel/report/all`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function exportAll() {
  return request({
    url:    `/action/wheel/awards/export`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

const WheelService = {
  reportAll, exportAll
}

export default WheelService;
